module.exports = __webpack_public_path__ + "img/1.8b0d8635.jpg";